import { Dialog } from "primereact/dialog";
import styled from "styled-components";

export const ThemedDialog = styled(Dialog)`
  &.p-dialog {
    border-radius: 14px;
    overflow: hidden;
    box-shadow: 0 24px 64px rgba(24, 24, 24, 0.22);
  }

  & .p-dialog-content,
  & .p-dialog-header {
    background: #ffffff;
  }

  & .p-dialog-header {
    position: absolute;
    top: 0;
    right: 0;
    z-index: 2;
    padding: 12px 12px 0 0;
    border-bottom: none;
    background: transparent;
  }

  & .p-dialog-content {
    padding: 32px;
  }

  & .p-dialog-header-icons button {
    color: #5a5959;
    width: auto;
    height: auto;
    padding: 8px;
    border: none;
    border-radius: 0;
    background: transparent;
    box-shadow: none;
    margin: 0;

    &:hover {
      background: transparent;
    }

    &:focus,
    &:focus-visible {
      outline: none;
      box-shadow: none;
    }

    & svg {
      display: block;
    }
  }
`;

export const DialogWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
`;

export const DialogTitle = styled.h2`
  margin: 0;
  color: #181818;
  font-family: Inter, sans-serif;
  font-size: 24px;
  font-weight: 600;
  line-height: 32px;
  letter-spacing: 0;
`;

export const DialogText = styled.p`
  margin: 0;
  color: #181818;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 400;
  line-height: 22px;
  letter-spacing: 0;
  max-width: 500px;
`;

export const DialogField = styled.div<{ $gap?: string }>`
  display: flex;
  flex-direction: column;
  gap: ${({ $gap = "16px" }) => $gap};
`;

export const DialogLabel = styled.label`
  color: #181818;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

export const DialogInput = styled.input`
  width: 100%;
  padding: 10px 14px;
  border: 1px solid #cfd7de;
  border-radius: 6px;
  background: #ffffff;
  color: #181818;
  font-family: Inter, sans-serif;
  font-size: 16px;
  line-height: 22px;

  &:focus-visible {
    outline: 2px solid rgba(6, 95, 166, 0.2);
    outline-offset: 0;
    border-color: #065fa6;
  }
`;

export const DialogError = styled.p`
  margin: 0;
  color: #b42318;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
`;

export const DialogActions = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 12px;

  @media (max-width: 768px) {
    flex-direction: column-reverse;
    align-items: stretch;
  }
`;

const BaseDialogButton = styled.button`
  padding: 8px 20px;
  border-radius: 6px;
  font-family: Inter, sans-serif;
  font-size: 16px;
  font-weight: 600;
  line-height: 22px;
  cursor: pointer;
  transition:
    background-color 0.2s ease,
    border-color 0.2s ease,
    color 0.2s ease;

  @media (max-width: 768px) {
    width: 100%;
    min-width: 0;
  }
`;

export const SecondaryDialogButton = styled(BaseDialogButton)`
  border: 1.5px solid #065fa6;
  background: #ffffff;
  color: #065fa6;

  &:hover {
    border-color: #181818;
    color: #181818;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const PrimaryDialogButton = styled(BaseDialogButton)`
  border: 1.5px solid #065fa6;
  background: #065fa6;
  color: #ffffff;

  &:hover {
    border-color: #181818;
    background: #181818;
  }

  &:disabled {
    cursor: not-allowed;
    opacity: 0.6;
  }
`;

export const SuccessBanner = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 4px;
  padding: 12px 16px;
  border: 1px solid #b7ebd3;
  border-radius: 8px;
  background: #effcf5;
  width: fit-content;
  max-width: 360px;
  margin-left: auto;
`;

export const SuccessBannerContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 8px;
`;

export const SuccessBannerIcon = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
`;

export const SuccessBannerText = styled.p`
  margin: 0;
  color: #181818;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
`;

export const SuccessBannerActions = styled.div`
  display: inline-flex;
  align-items: center;
  gap: 12px;
  flex: 0 0 auto;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-end;
  }
`;

export const SuccessBannerAction = styled.button`
  border: none;
  background: transparent;
  text-decoration: underline;
  font-family: Inter, sans-serif;
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
  padding: 0;
  cursor: pointer;

  &:hover {
    color: #181818;
  }
`;

export const SuccessBannerDismiss = styled.button`
  border: none;
  background: transparent;
  color: #5a5959;
  font-size: 14px;
  line-height: 1;
  padding: 0;
  cursor: pointer;
`;
